export enum PerformanceFetchingStatus {
  Default = 'default',
  Loading = 'loading',
  Error = 'error'
}
